import styled, { css } from 'styled-components';

export const Avatar = styled.img`
  height: 10rem;
  width: 10rem;
  border-radius: 50%;
  margin-bottom: 1rem;
`;

export const Header = styled.div`
  padding: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  ${({ theme }) => css`
    background: ${theme.colors.surface};
    border-top-right-radius: calc(${theme.border.radius.large} * 2);
    border-top-left-radius: calc(${theme.border.radius.large} * 2);

    h1 {
      font-size: ${theme.font.sizes.xxlarge};
    }

    p {
      font-size: ${theme.font.sizes.small};
      color: ${theme.colors.highContrast};
      margin-top: 0.5rem;
    }
  `}
`;

export const Content = styled.div`
  padding: 3rem;
  display: flex;
  flex-direction: column;

  ${({ theme }) => css`
    border-bottom-right-radius: calc(${theme.border.radius.large} * 2);
    border-bottom-left-radius: calc(${theme.border.radius.large} * 2);
  `}
`;

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    margin: 1rem 0;
    justify-content: space-between;
    width: 100%;
    align-items: center;

    > div {
      width: 100%;
    }

    small {
      svg {
        color: ${theme.colors.contrast};
        margin-right: 1rem;
      }
    }
  `}
`;
